import * as React from "react";
import type { SVGProps } from "react";
const SvgMinus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill={props.color || "#F7F7F8"}
    viewBox="0 0 12 2"
    {...props}
  >
    <path
      d="M12 1a.5.5 0 0 1-.5.5H.5a.5.5 0 0 1 0-1h11a.5.5 0 0 1 .5.5"
    />
  </svg>
);
export default SvgMinus;
